import { flagLabel, techniqueLabel, textValue } from '@entities'

// Retained raw fields for metadata and export.
export const rdsColumns = [
  { label: 'Site ID', key: 'site_id' },
  { label: 'Asset ID', key: 'asset_id' },
  { label: 'RDS-PP', key: 'rds_code' },
  { label: 'Description', key: 'description' },
  { label: 'Subsystem', key: 'subsystem' },
  { label: 'Root component', key: 'is_root' },
  { label: 'GVI eligible', key: 'in_gvi' },
  { label: 'RVI eligible', key: 'in_rvi' },
  { label: 'CVI eligible', key: 'in_cvi' },
  { label: 'FVI eligible', key: 'in_fvi' }
]

export const componentTableColumns = [
  { label: 'Component / RDS-PP', key: 'rds_code', value: row => row.rds_code },
  {
    label: 'Asset / site',
    key: 'location',
    value: row => row.assetLabel + ' ' + row.siteLabel
  },
  {
    label: 'Subsystem',
    key: 'subsystem',
    value: row => textValue(row.subsystem) || 'Unknown'
  },
  { label: 'Eligible techniques', key: 'technique', value: techniqueLabel },
  { label: 'Root', key: 'is_root', value: row => flagLabel(row.is_root) }
]
